import type { ReactNode } from "react";
import { cx } from "./cx.js";

export function EmptyState({
  icon,
  title,
  message,
  action,
  className,
}: {
  icon?: ReactNode;
  title: ReactNode;
  message?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cx(
        "flex flex-col items-center justify-center rounded-xl border border-dashed border-app-border bg-app-surface px-6 py-12 text-center",
        className,
      )}
    >
      {icon ? (
        <div className="mb-3 text-app-muted [&_svg]:h-10 [&_svg]:w-10">
          {icon}
        </div>
      ) : null}
      <h3 className="text-base font-semibold text-app-text">{title}</h3>
      {message ? (
        <p className="mt-1 max-w-sm text-sm text-app-muted">{message}</p>
      ) : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}
